import { h } from 'preact';

const CartSkeleton = () => (
  <div className="w-full h-full flex flex-col justify-between md:flex-row md:items-start">
    <div className="mt-5 mb-5 mx-5 md:mr-0 md:ml-10 md:mt-16 md:mb-0 md:w-[56%]">
      <h2 className="capitalize md:mb-5">Shopping Bag ()</h2>
      <div className="flex gap-5 py-5 lg:mb-5 border-[#F4F1E6] border-b-[1px] border-solid md:last-of-type:border-none">
        <div className="w-[120px] max-w-[120px] min-w-[120px] md:w-1/3 h-[180px] bg-gray-200"></div>
        <div className="details md:w-full">
          <div className="flex justify-between gap-3">
            <span className="h7--medium md:text-sm text-text-default w-[140px] h-[20px] bg-gray-200"></span>
            <p className="flex gap-1 md:text-sm bg-gray-200 h-[20px] w-[31px]"></p>
          </div>
          <a className="no-underline body-3 md:text-sm text-text-default bg-gray-200 w-[200px] h-[17.5px]"></a>
          <div className="mt-2.5 md:mt-5">
            <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
            <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
          </div>
          <button className="flex bg-core-1 justify-between items-center py-1.5 px-2 gap-12 mt-2.5 lg:mt-5 w-[192px] h-[31.2px]"></button>
          <div className="flex items-center mt-2.5 laptop:mt-0 laptop:basis-[39%] laptop:items-start laptop:mt-0 laptop:justify-center laptop:pl-[3%] w-[145px] bg-gray-200 h-[38px]">
            <div className="flex border border-border-gray font-r-18 laptop:px-2"></div>
            <button className="text-xs underline text-default ml-5"></button>
          </div>
          <button className="text-xs md:text-sm mt-5 md:mt-6 underline underline-offset-[2.5px] text-default bg-gray-200 w-[112px] h-[20px]"></button>
        </div>
      </div>
      <div className="flex gap-5 py-5 lg:mb-5 border-[#F4F1E6] border-b-[1px] border-solid md:last-of-type:border-none">
        <div className="w-[120px] max-w-[120px] min-w-[120px] md:w-1/3 h-[180px] bg-gray-200"></div>
        <div className="details md:w-full">
          <div className="flex justify-between gap-3">
            <span className="h7--medium md:text-sm text-text-default w-[140px] h-[20px] bg-gray-200"></span>
            <p className="flex gap-1 md:text-sm bg-gray-200 h-[20px] w-[31px]"></p>
          </div>
          <a className="no-underline body-3 md:text-sm text-text-default bg-gray-200 w-[200px] h-[17.5px]"></a>
          <div className="mt-2.5 md:mt-5">
            <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
            <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
          </div>
          <button className="flex bg-core-1 justify-between items-center py-1.5 px-2 gap-12 mt-2.5 lg:mt-5 w-[192px] h-[31.2px]"></button>
          <div className="flex items-center mt-2.5 laptop:mt-0 laptop:basis-[39%] laptop:items-start laptop:mt-0 laptop:justify-center laptop:pl-[3%] w-[145px] bg-gray-200 h-[38px]">
            <div className="flex border border-border-gray font-r-18 laptop:px-2"></div>
            <button className="text-xs underline text-default ml-5"></button>
          </div>
          <button className="text-xs md:text-sm mt-5 md:mt-6 underline underline-offset-[2.5px] text-default bg-gray-200 w-[112px] h-[20px]"></button>
        </div>
      </div>
      <div className="flex gap-5 py-5 lg:mb-5 border-[#F4F1E6] border-b-[1px] border-solid md:last-of-type:border-none">
        <div className="w-[120px] max-w-[120px] min-w-[120px] md:w-1/3 h-[180px] bg-gray-200"></div>
        <div className="details md:w-full">
          <div className="flex justify-between gap-3">
            <span className="h7--medium md:text-sm text-text-default w-[140px] h-[20px] bg-gray-200"></span>
            <p className="flex gap-1 md:text-sm bg-gray-200 h-[20px] w-[31px]"></p>
          </div>
          <a className="no-underline body-3 md:text-sm text-text-default bg-gray-200 w-[200px] h-[17.5px]"></a>
          <div className="mt-2.5 md:mt-5">
            <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
            <p className="body-3 text-text-default md:text-sm bg-gray-200 h-[20px] w-[150px]"></p>
          </div>
          <button className="flex bg-core-1 justify-between items-center py-1.5 px-2 gap-12 mt-2.5 lg:mt-5 w-[192px] h-[31.2px]"></button>
          <div className="flex items-center mt-2.5 laptop:mt-0 laptop:basis-[39%] laptop:items-start laptop:mt-0 laptop:justify-center laptop:pl-[3%] w-[145px] bg-gray-200 h-[38px]">
            <div className="flex border border-border-gray font-r-18 laptop:px-2"></div>
            <button className="text-xs underline text-default ml-5"></button>
          </div>
          <button className="text-xs md:text-sm mt-5 md:mt-6 underline underline-offset-[2.5px] text-default bg-gray-200 w-[112px] h-[20px]"></button>
        </div>
      </div>
    </div>
    <div className="desktop_summary hidden w-[32%] p-10 mt-12 mr-5 md:mr-10 md:flex flex-col border-background-3 border-solid border">
      <h2 className="capitalize mb-7">Order Summary</h2>
      <div className="desktop_order_details flex flex-col gap-2">
        <div className="totals bg-core-0 flex flex-col px-5 py-5 sticky bottom-0">
          <div className="flex justify-between mb-2.5">
            <p className="capitalize text-sm font-medium">Subtotal&nbsp;</p>
            <p className="flex gap-3 text-sm font-medium">$XXX</p>
          </div>
          <div className="flex justify-between mb-2.5">
            <p className="capitalize text-sm">Taxes&nbsp;</p>
            <p className="capitalize text-sm">Calculated at checkout</p>
          </div>
          <a
            className="justify-center w-full button button--primary no-underline"
            href="/checkout"
          >
            Checkout
          </a>
        </div>
      </div>
    </div>
    <div className="totals bg-core-0 flex flex-col px-5 py-5 sticky bottom-0 md:hidden">
      <div className="flex justify-between mb-4 lg:mb-1"></div>
      <div className="flex justify-between mb-4"></div>
      <div className="flex justify-between mb-4 lg:mb-1"></div>
      <a className="justify-center w-full button button--primary no-underline"></a>
    </div>
    <div className="px-5 py-[30px] bg-white md:hidden">
      <p className="px-5 py-2.5 text-sm bg-core-0"></p>
    </div>
    <div className="dynamic_checkout empty:hidden p-5 bg-core-0 md:hidden">
      <h2 className="body-1--medium text-center mb-[6px]"></h2>
      <div className="dynamic-checkout__buttons"></div>
    </div>
  </div>
);

export default CartSkeleton;
